import { render } from "./SportsManagement.vue?vue&type=template&id=f969fac4&scoped=true"
import script from "./SportsManagement.vue?vue&type=script&lang=js"
export * from "./SportsManagement.vue?vue&type=script&lang=js"

import "./SportsManagement.vue?vue&type=style&index=0&id=f969fac4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f969fac4"]])

export default __exports__